// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The layer order first, for the reason EsGame.css gives. */
@layer theme, base, primereact, components, utilities;

/* EsScrollEdges: the box's own content fades out over --es-edge-fade at an
   edge with more beyond it. A mask rather than an overlay: it needs no colour
   to match the ground, and nothing sits over the content to catch a click. */
@layer components {
    .esScrollEdges {
        --es-edge-fade: 1.25rem;
    }

    .esScrollEdges[data-edge-top="true"] {
        mask-image: linear-gradient(to bottom, transparent, #000 var(--es-edge-fade));
    }

    .esScrollEdges[data-edge-bottom="true"] {
        mask-image: linear-gradient(to top, transparent, #000 var(--es-edge-fade));
    }

    .esScrollEdges[data-edge-top="true"][data-edge-bottom="true"] {
        mask-image: linear-gradient(
            to bottom,
            transparent,
            #000 var(--es-edge-fade),
            #000 calc(100% - var(--es-edge-fade)),
            transparent
        );
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
